module.exports = __webpack_public_path__ + "static/media/automobile.883fba7a.svg";